import { Navigate } from "react-router-dom";
import { getToken } from "../services/tokenService";

const PublicRoute = ({ children }) => {
  const token = getToken();

  if (token) {
    return <Navigate to="/voucher" />;
  }

  return children;
};

export default PublicRoute;